import React from 'react';
import styles from './OrganizationItem.module.scss';
import { Form, Tooltip } from 'antd';
import { ReactComponent as DeleteIcon } from '../../../../resource/DeleteIcon.svg';
import DropdownSelect from '../../../../components/dropdownSelect';
import { getDocOptionsOrgsSelect } from '../../utils/getDocOptionsSelect';
import { getRenderControl } from '../../../../components/SingleControlCustom/getRenderControl';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';

const OrganizationItem = ({
  form,
  index,
  allowDelete,
  deleteItem,
  data,
  isFetching,
}) => {
  const { getFieldDecorator, getFieldValue } = form;

  const { mode } = useSelector(documentDrawerSelector);

  const companyId = getFieldValue('serviceCompanyId');

  const isDisabled = !companyId && mode === 'create';

  return (
    <div className={styles.root}>
      <Form.Item
        label="Адресат"
        className={styles.item}
      >
        <Tooltip
          title={
            isDisabled ? 'Укажите компанию, чтобы выбрать организацию' : ''
          }
        >
          <div>
            {getFieldDecorator(`orgId[${index}]`, {
              rules: [
                {
                  required: true,
                  message:
                    'Пожалуйста, укажите организацию отправителя/получателя документа',
                },
              ],
            })(
              <DropdownSelect
                disabled={isDisabled}
                loading={isFetching}
                multiple={false}
                options={getDocOptionsOrgsSelect(data)}
                renderControl={getRenderControl({
                  options: getDocOptionsOrgsSelect(data),
                  isClear: false,
                  value: getFieldValue(`orgId[${index}]`),
                  placeholder: 'Организация',
                  disabled: isDisabled,
                  loading: isFetching,
                })}
              />
            )}
          </div>
        </Tooltip>
      </Form.Item>

      {allowDelete && (
        <DeleteIcon
          style={{ cursor: 'pointer', fill: '#F93336', marginBottom: 10 }}
          onClick={() => deleteItem(index)}
        />
      )}
    </div>
  );
};

export default OrganizationItem;
